import React from "react";
import { Modal, Fade, Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../features/AuthSlice";
import { setLoginData } from "../../features/LoginDataSlice";
import { persistStore } from "redux-persist";
import { store } from "../../store/Store";
import SuccessPopupDashboard from "../Popups/PopupFrame/SuccessPopupDashboard";
import logoutPopupImg from "../../assets/images/png/Group 92@2x.png"

const LogoutConfirmation = ({ 
  open, 
  onClose, 
  buyerBtn, 
  vendorBtn, 
  buyerBtnOutline, 
  vendorBtnOutlined 
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    onClose();
    navigate("/login");
    dispatch(logOut());
    persistStore(store).purge(["log", "Admin", "main"]);
    dispatch(setLoginData([]));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Fade in={open}>
        <Box>
          <SuccessPopupDashboard
            popupImage={logoutPopupImg}
            popupHeroText={"Are you sure want to logout?"}
            popBtn={true}
            btnText={"Yes"}
            buyerBtn={buyerBtn}
            buyerBtnOutline={buyerBtnOutline}
            vendorBtn={vendorBtn}
            vendorBtnOutlined={vendorBtnOutlined}
            secondaryBtn={true}
            btnTextSecondary={"Cancel"}
            btnClick={handleLogout}
            btnClickSecondary={onClose}
          />
        </Box>
      </Fade>
    </Modal>
  );
};

export default LogoutConfirmation;